import { jsx as r, jsxs as x } from "react/jsx-runtime";
import { useId as h } from "react";
import { q as m } from "../index-DiWzAyMV.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import '../List.css';const g = "_list_gk5l9_1", d = "_listItem_gk5l9_10", z = "_listItemText_gk5l9_16", f = "_iconWrapper_gk5l9_20", T = "_check_gk5l9_28", i = {
  list: g,
  listItem: d,
  listItemText: z,
  iconWrapper: f,
  check: T,
  "size--s": "_size--s_gk5l9_32",
  "size--m": "_size--m_gk5l9_44"
}, W = { s: "xsm", m: "sm" }, b = ({ classNames: t, direction: e, items: _, size: n = "m", ...p }) => {
  const l = h(), c = e ? { flexDirection: e } : {};
  return /* @__PURE__ */ r(
    "ul",
    {
      className: o(i.list, i[`size--${n}`], t == null ? void 0 : t.wrapper),
      "data-cxy-name": "list",
      style: c,
      ...p,
      children: _.map((I, k) => /* @__PURE__ */ x("li", { className: o(i.listItem, t == null ? void 0 : t.listItem), children: [
        /* @__PURE__ */ r("span", { className: o(i.iconWrapper, t == null ? void 0 : t.iconWrapper), children: /* @__PURE__ */ r(m, { className: o(i.check, t == null ? void 0 : t.checkIcon), color: "blue", size: W[n] }) }),
        /* @__PURE__ */ r("span", { className: o(i.listItemText, t == null ? void 0 : t.listItemText), children: I })
      ] }, `list-${l}-item-${k}`))
    }
  );
};
export {
  b as List
};
